import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';

const propTypes = {
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    logo_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
};

const AccountMarketingMaterialProfilePagePrintTemplate = ({ account }) => {
  const logoUrl = account?.logo_image?.url;
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);
  const url = `https://waldophotos.com/@${account.username}`;

  return (
    <Fragment>
      {logoUrl && (
        <div
          style={{
            top: '12%',
            right: '5%',
            height: '29%',
            width: '23%',
          }}
          className="marketing-material-social-account-logo"
        >
          <img
            src={logoUrl}
            alt=""
            className="marketing-material-social-account-logo-image"
          />
        </div>
      )}

      <p
        style={{
          fontSize: '2vw',
          top: '57.8%',
          left: '10.5%',
        }}
        className="marketing-material-flyer-target-enroll-copy"
      >
        Visit{' '}
        <strong>
          <a href={url}>waldophotos.com/@{account.username}</a>
        </strong>
      </p>

      <div
        style={{
          top: '52.5%',
          right: '6.8%',
        }}
        className="marketing-material-flyer-qrcode-secondary"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder: {
              id: account.id,
              account,
            },
          })}
          size={width * 0.18 ?? 500}
        />
      </div>

      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_SOCIAL_PROFILE_PAGE_TEMPLATE.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

AccountMarketingMaterialProfilePagePrintTemplate.propTypes = propTypes;

export default AccountMarketingMaterialProfilePagePrintTemplate;
